import * as Popover from "@radix-ui/react-popover";
import { Box, IconButton, Text, Theme } from "@radix-ui/themes";
import { HelpCircle } from "lucide-react";

interface Props {
  title?: string;
  children: React.ReactNode;
  ariaLabel?: string;
}

export default function HelpPopover({ title, children, ariaLabel = "Show help" }: Props) {
  return (
    <Popover.Root>
      <Popover.Trigger asChild>
        <IconButton variant="ghost" size="1" aria-label={ariaLabel} type="button">
          <HelpCircle size={14} />
        </IconButton>
      </Popover.Trigger>
      <Popover.Portal>
        <Theme>
          <Popover.Content
            align="start"
            sideOffset={6}
            style={{
              maxWidth: 320,
              padding: 12,
              zIndex: 12000,
              background: "var(--color-panel-solid)",
              border: "1px solid var(--gray-a5)",
              borderRadius: "var(--radius-3)",
              boxShadow: "var(--shadow-4)",
            }}
          >
            {title && (
              <Box mb="1">
                <Text size="2" weight="medium">{title}</Text>
              </Box>
            )}
            <Text size="1" color="gray" style={{ display: "block" }}>{children}</Text>
          </Popover.Content>
        </Theme>
      </Popover.Portal>
    </Popover.Root>
  );
}
